const personalityTypes = [
  {
    code: 'ai',
    role: 'Creatieve Communicator',
  },
  {
    code: 'aimin',
    role: 'Geduldige Luisteraar',
  },
  {
    code: 'amini',
    role: 'Gedreven Initiator',
  },
  {
    code: 'aminimin',
    role: 'Gereserveerde Individualist',
  },
  {
    code: 'aminp',
    role: 'Onafhankelijke Leider',
  },
  {
    code: 'aminpmin',
    role: 'Bescheiden Ondersteuner',
  },
  {
    code: 'amins',
    role: 'Gedisciplineerde Individualist',
  },
  {
    code: 'aminsmin',
    role: 'Flexibele Autonoom',
  },
  {
    code: 'ap',
    role: 'Verbindende Leider',
  },
  {
    code: 'apmin',
    role: 'Bescheiden Ondersteuner',
  },
  {
    code: 'as',
    role: 'Betrouwbare Communicator',
  },
  {
    code: 'asmin',
    role: 'Ontspannen Communicator',
  },
  {
    code: 'ia',
    role: 'Creatieve Communicator',
  },
  {
    code: 'iamin',
    role: 'Gedreven Initiator',
  },
  {
    code: 'imina',
    role: 'Geduldige Luisteraar',
  },
  {
    code: 'iminamin',
    role: 'Gereserveerde Individualist',
  },
  {
    code: 'iminp',
    role: 'Traditionele Leider',
  },
  {
    code: 'iminpmin',
    role: 'Bescheiden Ondersteuner',
  },
  {
    code: 'imins',
    role: 'Betrouwbare Doorzetter',
  },
  {
    code: 'iminsmin',
    role: 'Flexibele Ondersteuner',
  },
  {
    code: 'ip',
    role: 'Inspirerende Leider',
  },
  {
    code: 'ipmin',
    role: 'Bescheiden Innovator',
  },
  {
    code: 'is',
    role: 'Creatieve Doorzetter',
  },
  {
    code: 'ismin',
    role: 'Enthousiaste Starter',
  },
  {
    code: 'pa',
    role: 'Verbindende Leider',
  },
  {
    code: 'pamin',
    role: 'Onafhankelijke Leider',
  },
  {
    code: 'pi',
    role: 'Inspirerende Leider',
  },
  {
    code: 'pimin',
    role: 'Traditionele Leider',
  },
  {
    code: 'pmina',
    role: 'Bescheiden Ondersteuner',
  },
  {
    code: 'pminamin',
    role: 'Bescheiden Ondersteuner',
  },
  {
    code: 'pmini',
    role: 'Bescheiden Innovator',
  },
  {
    code: 'pminimin',
    role: 'Bescheiden Ondersteuner',
  },
  {
    code: 'pmins',
    role: 'Bescheiden Doorzetter',
  },
  {
    code: 'pminsmin',
    role: 'Relaxte Volger',
  },
  {
    code: 'ps',
    role: 'Structurerende Leider',
  },
  {
    code: 'psmin',
    role: 'Losse Leider',
  },
  {
    code: 'sa',
    role: 'Betrouwbare Communicator',
  },
  {
    code: 'samin',
    role: 'Gedisciplineerde Individualist',
  },
  {
    code: 'si',
    role: 'Creatieve Doorzetter',
  },
  {
    code: 'simin',
    role: 'Betrouwbare Doorzetter',
  },
  {
    code: 'smina',
    role: 'Ontspannen Communicator',
  },
  {
    code: 'sminamin',
    role: 'Flexibele Autonoom',
  },
  {
    code: 'smini',
    role: 'Enthousiaste Starter',
  },
  {
    code: 'sminimin',
    role: 'Flexibele Ondersteuner',
  },
  {
    code: 'sminp',
    role: 'Losse Leider',
  },
  {
    code: 'sminpmin',
    role: 'Relaxte Volger',
  },
  {
    code: 'sp',
    role: 'Strucuterende Leider',
  },
  {
    code: 'spmin',
    role: 'Bescheiden Doorzetter',
  },
]

export default personalityTypes
